import { MONTHS, WEEKDAYS } from '../functions/date_format_helpers';

/**
 * Chart locales
 */
export function getLocales(I18n) {
  return [
    {
      name: I18n.locale,
      options: {
        months: MONTHS.map((month) => I18n.t(`months.longhand.${month}`)),
        shortMonths: MONTHS.map((month) => I18n.t(`months.shorthand.${month}`)),
        days: WEEKDAYS.map((day) => I18n.t(`day.${day}`)),
        shortDays: WEEKDAYS.map((day) => I18n.t(`days.shorthand.${day}`)),
        toolbar: {
          download: I18n.t('chart.download'),
          selection: I18n.t('chart.selection'),
          selectionZoom: I18n.t('chart.selection_zoom'),
          zoomIn: I18n.t('chart.zoom_in'),
          zoomOut: I18n.t('chart.zoom_out'),
          pan: I18n.t('chart.panning'),
          reset: I18n.t('chart.reset_zoom'),
        },
      },
    },
  ];
}

/**
 * Colours specific to the risk series
 */
export const riskSeriesColours = [
  '#E9413A',
  '#EB6C0E',
  '#E89C00',
  '#92A335',
  '#D5D4D6',
];

/**
 * Colours specific to the condition series
 */
export const conditionSeriesColours = [
  '#E9413A',
  '#EB6C0E',
  '#E89C00',
  '#92A335',
  '#54755E',
  '#6D7372',
  '#D5D4D6',
];

/**
 * Colours specific to the priority series.
 */
export const prioritySeriesColours = [
  '#E9413A',
  '#EB6C0E',
  '#E89C00',
  '#92A335',
  '#54755E',
  '#6D7372',
  '#D5D4D6',
];

/**
 * Colours specific to the Total series
 */
export const totalSeriesColours = [
  '#D5D4D6',
  '#D5D4D6',
  '#D5D4D6',
  '#D5D4D6',
  '#D5D4D6',
  '#D5D4D6',
  '#D5D4D6',
];

/**
 * Colours specific to the condition 5
 */
export const condition5ColoursIndex = [
  '#E9413A',
  '#D5D4D6',
];

/**
 * Colours specific to the condition 4
 */
export const condition4ColoursIndex = [
  '#EB6C0E',
  '#D5D4D6',
];

/**
 * Colours specific to the inspection history series
 */
export const historySeriesColours = [
  '#1C87D9',
  '#7FDFFF',
];

/**
 * Reference: https://apexcharts.com/docs/options/tooltip/
 */
export const toolTipOptions = {
  enabled: true,
  shared: true,
  followCursor: true,
  fillSeriesColor: false,
  theme: true,
  style: {
    fontSize: '12px',
  },
  x: {
    show: true,
    format: 'dd MMM y',
  },
};

/**
 * Reference: https://apexcharts.com/docs/options/chart/toolbar/
 */
export const toolBarOptions = {
  show: true,
  tools: {
    download: false,
    selection: true,
    zoom: true,
    zoomin: true,
    zoomout: true,
    pan: true,
    reset: false | '<img src="/public/logo.png" width="20">',
    customIcons: [],
  },
};

/**
 * Reference: https://apexcharts.com/docs/options/chart/zoom/
 */
export const zoomOptions = {
  enabled: true,
  type: 'x',
  autoScaleYaxis: false,
};

/**
 * Reference: https://apexcharts.com/docs/options/markers/
 */
export const markerOptions = {
  size: 0,
  colors: [],
  strokeColors: '#fff',
  strokeWidth: 1,
  strokeOpacity: 0.9,
  strokeDashArray: 0,
  fillOpacity: 1,
  discrete: [],
  shape: 'circle',
  radius: 2,
  offsetX: 0,
  offsetY: .5,
  hover: {
    sizeOffset: 3,
  },
};

/**
 * Reference: https://apexcharts.com/docs/options/stroke/
 */
export const strokeOptions = {
  show: true,
  curve: 'stepline',
  width: 1.55,
  dashArray: 0,
};

/**
 * Reference: https://apexcharts.com/docs/options/grid/
 */
export const gridOptions = {
  show: true,
  borderColor: '#98979940',
  padding: {
    top: 0,
    bottom: 0,
  },
};

/**
 * Reference: https://apexcharts.com/docs/options/fill/
 */
export const fillOptions = {
  colors: [],
  gradient: {
    enabled: true,
    opacityFrom: 0.45,
    opacityTo: 0,
  },
};

/**
 * Reference: https://apexcharts.com/docs/options/xaxis/
 */
export const xAxisOptions = {
  type: 'datetime',
  tooltip: {
    enabled: false,
  },
};
